export function trackInteraction(eventType, metadata = {}) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
    if (!csrfToken) return;

    // Product analytics must never interrupt the action the user just took.
    fetch('/academy/interaction_events', {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken },
        body: JSON.stringify({ event_type: eventType, ...metadata })
    }).catch(() => {});
}
